import { render, staticRenderFns } from "./board_add_new_column_form.vue?vue&type=template&id=f29a371a&"
import script from "./board_add_new_column_form.vue?vue&type=script&lang=js&"
export * from "./board_add_new_column_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports